// extracted by mini-css-extract-plugin
export default {"image":"RightImage_image__uMJRh"};